import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";

const PlInsightBenchmark = Loadable(
  lazy(() =>
    import("./PlInsightBenchmark").then(({ PlInsightBenchmark }) => ({
      default: PlInsightBenchmark,
    }))
  )
);

export const dashboardSettingsRoutes = [
  {
    path: "/settings/dashboard-settings/pl-insight-benchmark",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <PlInsightBenchmark />
      </AuthorizedRoute>
    ),
  },
];
